import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  scraps: [],
};

const getters = {
  allScraps: (state) => state.scraps,
};

const actions = {
  async fetchScraps({ commit }, params = {}) {
    try {
      commit("resetScraps");
      const response = await axios.get("/scrap", { params: prm(params) });
      commit("setScraps", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch scraps:", error);
    }
  },
  async createScrap({ commit }, scrap) {
    try {
      const response = await axios.post("/scrap", scrap);
      commit("addScrap", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create scrap:", error);
      throw error;
    }
  },
  async fetchScrapById(_, id) {
    try {
      const response = await axios.get(`/scrap/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch scrap:", error);
      throw error;
    }
  },
  async updateScrap({ commit }, scrap) {
    try {
      const response = await axios.put(`/scrap/${scrap.id}`, scrap);
      commit("updateScrap", response.data);
    } catch (error) {
      console.error("Failed to update scrap:", error);
      throw error;
    }
  },
  async closeScrap({ commit }, scrap) {
    try {
      const response = await axios.post(`/scrap/close`, scrap);
      commit("closeScrap", response.data);
    } catch (error) {
      console.error("Failed to close scrap:", error);
      throw error;
    }
  },
  async deleteScrapById({ commit }, id) {
    try {
      const response = await axios.delete(`/scrap/${id}`);
      commit("removeScrap", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete scrap:", error);
      throw error;
    }
  },
};

const mutations = {
  setScraps(state, scraps) {
    state.scraps = scraps.data; // Ensure this matches your API's response structure
  },
  addScrap(state, scrap) {
    state.scraps.push(scrap);
  },
  updateScrap(state, updatedScrap) {
    const index = state.scraps.findIndex(
      (scrap) => scrap.id === updatedScrap.id
    );
    if (index !== -1) {
      state.scraps.splice(index, 1, updatedScrap);
    }
  },
  removeScrap(state, id) {
    state.scraps = state.scraps.filter(
      (scrap) => scrap.id !== id
    );
  },
  resetScraps(state) {
    state.scraps = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
